import { render } from "./StyleImage.vue?vue&type=template&id=0524d586&scoped=true"
import script from "./StyleImage.vue?vue&type=script&lang=js"
export * from "./StyleImage.vue?vue&type=script&lang=js"

import "./StyleImage.vue?vue&type=style&index=0&id=0524d586&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\houbkar\\WebstormProjects\\PO\\2022-PO-LMO-HTML\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0524d586"]])

export default __exports__